import React from 'react'
import { Form, Formik } from 'formik'

import Input from '../../components/common/Input'
import { required } from '../../utils/validators'
import Button from '../../components/common/Button'
import Select from '../../components/common/Select'
import { paymentTypeOptions, tur } from '../../utils/types'
import { useLoad } from '../../hooks/request'
import { TOTAL_EXPENSE_CATEGORY_LIST } from '../../urls'

export default function TotalExpenseForm({ onCancel, onSubmit, loading, initialValues }) {
    const { response: categoryResponse } = useLoad({
        url: TOTAL_EXPENSE_CATEGORY_LIST,
        params: { size: 1000 },
    })
    const categoryItems = categoryResponse ? categoryResponse.results : []

    return (
        <Formik
            onSubmit={onSubmit}
            initialValues={{
                status: 'expenses',
                note: '',
                amount: '',
                category: '',
                types: '',
                date: '',
                ownWork: false,
                paymentType: '', // Default to naqd
                ...initialValues,
            }}
        >
            <Form>
                <div className="columns">
                    <div className="column">
                        <Input name="date" type="date" label="Сана" validate={required} disabled={loading} />
                        <Select validate={required} empty name="category" options={categoryItems} label="Категория" disabled={loading} />
                        <Select optionValue="value" optionLabel="name" validate={required} empty name="types" options={tur} label="Тур" disabled={loading} />
                        <Select optionValue="value" optionLabel="name" name="paymentType" label="То'лов тури" options={paymentTypeOptions} disabled={loading} />
                        <Input name="amount" type="number" label="Цена" validate={required} disabled={loading} />
                        <Input component="textarea" name="comment" label="Примечание" validate={required} disabled={loading} />
                    </div>
                </div>

                <div style={{ gap: 5 }} className="buttons is-flex is-justify-content-space-between mt-4">
                    <div className="button-wrapper">
                        <Button onClick={onCancel} icon="close-outline" text="Ёпиш" className="is-danger" />
                    </div>
                    <div className="button-wrapper">
                        <Button loading={loading} text="Сақлаш" icon="add-outline" type="submit" className="is-success" />
                    </div>
                </div>
            </Form>
        </Formik>
    )
}
